export default "__VITE_ASSET__VA$uMSwH__"